import { render, staticRenderFns } from "./FlightsCached.vue?vue&type=template&id=4994fcae&scoped=true"
import script from "./FlightsCached.vue?vue&type=script&lang=js"
export * from "./FlightsCached.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4994fcae",
  null
  
)

export default component.exports